import { render, staticRenderFns } from "./ArtistInfoWrap.vue?vue&type=template&id=609b777f&"
import script from "./ArtistInfoWrap.vue?vue&type=script&lang=js&"
export * from "./ArtistInfoWrap.vue?vue&type=script&lang=js&"
import style0 from "./ArtistInfoWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports